import Vue from "vue";
import Router from "vue-router";
import AuthService from "../service/AuthService";
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
import DonViCungCapChoDuyetApi from "@/moduleApi/DonViCungCapChoDuyetApi";
import config from "../config.json";
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const DefaultContainerClient = () =>
  import("@/containers/DefaultContainerClient");

// Views - admin
const AdminDashboard = () => import("@/views/admin/Dashboard/Dashboard");
const AdminQuangCaoList = () => import("@/views/admin/QuangCao/QuangCaoList");
const AdminQuangCaoForm = () => import("@/views/admin/QuangCao/QuangCaoForm");
const LichSuQuangCaoList = () =>
  import("@/views/admin/QuangCao/LichSuQuangCaoList");
const LichSuQuangCaoForm = () =>
  import("@/views/admin/QuangCao/LichSuQuangCaoForm");
const AdminNguoiDungList = () =>
  import("@/views/admin/NguoiDung/NguoiDungList");
const AdminNguoiDungForm = () =>
  import("@/views/admin/NguoiDung/NguoiDungForm");
const AdminLienHeList = () => import("@/views/admin/LienHe/LienHeList");
const AdminLienHeForm = () => import("@/views/admin/LienHe/LienHeForm");
const AdminTourDuLichList = () =>
  import("@/views/admin/TourDuLich/TourDuLichList");
const AdminTourDuLichForm = () =>
  import("@/views/admin/TourDuLich/TourDuLichForm");
const LichSuTourDuLichList = () =>
  import("@/views/admin/TourDuLich/LichSuTourDuLichList");
const LichSuTourDuLichForm = () =>
  import("@/views/admin/TourDuLich/LichSuTourDuLichForm");
const AdminDiemDenList = () => import("@/views/admin/DiemDen/DiemDenList");
const AdminDiemDenForm = () => import("@/views/admin/DiemDen/DiemDenForm");
const LichSuDiemDenList = () =>
  import("@/views/admin/DiemDen/LichSuDiemDenList");
const LichSuDiemDenForm = () =>
  import("@/views/admin/DiemDen/LichSuDiemDenForm");
const AdminDiemDenFormCreate = () =>
  import("@/views/admin/DiemDen/DiemDenFormCreate");
const AdminDichVuDiemDenList = () =>
  import("@/views/admin/DichVuDiemDen/DichVuDiemDenList");
const AdminDichVuDiemDenForm = () =>
  import("@/views/admin/DichVuDiemDen/DichVuDiemDenForm");
const AdminLichSuDichVuDiemDenList = () =>
  import("@/views/admin/DichVuDiemDen/LichSuDichVuDiemDenList");
const AdminLichSuDichVuDiemDenForm = () =>
  import("@/views/admin/DichVuDiemDen/LichSuDichVuDiemDenForm");
const AdminLuuTruList = () => import("@/views/admin/LuuTru/LuuTruList");
const AdminLuuTruForm = () => import("@/views/admin/LuuTru/LuuTruForm");
const LichSuLuuTruList = () => import("@/views/admin/LuuTru/LichSuLuuTruList");
const LichSuLuuTruForm = () => import("@/views/admin/LuuTru/LichSuLuuTruForm");
const AdminAmThucList = () => import("@/views/admin/AmThuc/AmThucList");
const AdminAmThucForm = () => import("@/views/admin/AmThuc/AmThucForm");
const AdminAmThucFormCreate = () =>
  import("@/views/admin/AmThuc/AmThucFormCreate");
const LichSuAmThucList = () => import("@/views/admin/AmThuc/LichSuAmThucList");
const LichSuAmThucForm = () => import("@/views/admin/AmThuc/LichSuAmThucForm");
const AdminVeMayBayList = () => import("@/views/admin/VeDienTu/VeMayBayList");
const AdminVeMayBayForm = () => import("@/views/admin/VeDienTu/VeMayBayForm");
// const LichSuVeMayBayList = () =>
//     import ('@/views/admin/VeDienTu/LichSuVeMayBayList')
// const LichSuVeMayBayForm = () =>
//     import ('@/views/admin/VeDienTu/LichSuVeMayBayForm')
const AdminVeGiaoThongList = () =>
  import("@/views/admin/VeDienTu/VeGiaoThongList");
const AdminVeGiaoThongForm = () =>
  import("@/views/admin/VeDienTu/VeGiaoThongForm");
const AdminVeDienTuList = () => import("@/views/admin/VeDienTu/VeDienTuList");
const AdminVeDienTuForm = () => import("@/views/admin/VeDienTu/VeDienTuForm");
const AdminLichSuVeDienTuList = () =>
  import("@/views/admin/VeDienTu/LichSuVeDienTuList");
const AdminLichSuVeDienTuForm = () =>
  import("@/views/admin/VeDienTu/LichSuVeDienTuForm");
const AdminVeDienTuFormUpdate = () =>
  import("@/views/admin/VeDienTu/VeDienTuFormCreate");
const AdminVanTaiKhachList = () =>
  import("@/views/admin/VanTaiKhach/VanTaiKhachList");
const AdminVanTaiKhachForm = () =>
  import("@/views/admin/VanTaiKhach/VanTaiKhachForm");
// const AdminVanTaiKhachFormCreate = () =>
//   import('@/views/admin/VanTaiKhach/VanTaiKhachFormCreate')
const LichSuVanTaiKhachList = () =>
  import("@/views/admin/VanTaiKhach/LichSuVanTaiKhachList");
const LichSuVanTaiKhachForm = () =>
  import("@/views/admin/VanTaiKhach/LichSuVanTaiKhachForm");
const AdminDichVuVeDienTuList = () =>
  import("@/views/admin/DichVuVeDienTu/DichVuVeDienTuList");
const AdminDichVuVeDienTuForm = () =>
  import("@/views/admin/DichVuVeDienTu/DichVuVeDienTuForm");
const AdminLichSuDichVuVeDienTuList = () =>
  import("@/views/admin/DichVuVeDienTu/LichSuDichVuVeDienTuList");
const AdminLichSuDichVuVeDienTuForm = () =>
  import("@/views/admin/DichVuVeDienTu/LichSuDichVuVeDienTuForm");
const AdminSanVatList = () => import("@/views/admin/SanVat/SanVatList");
const AdminSanVatForm = () => import("@/views/admin/SanVat/SanVatForm");
const AdminVuiChoiGiaiTriList = () =>
  import("@/views/admin/VuiChoiGiaiTri/VuiChoiGiaiTriList");
const AdminVuiChoiGiaiTriForm = () =>
  import("@/views/admin/VuiChoiGiaiTri/VuiChoiGiaiTriForm");
const LichSuGiaiTriList = () =>
  import("@/views/admin/VuiChoiGiaiTri/LichSuGiaiTriList");
const LichSuGiaiTriForm = () =>
  import("@/views/admin/VuiChoiGiaiTri/LichSuGiaiTriForm");
const AdminGiaiTriFormCreate = () =>
  import("@/views/admin/VuiChoiGiaiTri/GiaiTriFormCreate");
const AdminTinTucList = () => import("@/views/admin/TinTuc/TinTucList");
const AdminTinTucForm = () => import("@/views/admin/TinTuc/TinTucForm");
const AdminDDATList = () => import("@/views/admin/DDAT/DDATList");
const AdminDDATForm = () => import("@/views/admin/DDAT/DDATForm");
const AdminThongTinDDATForm = () =>
  import("@/views/admin/DDAT/ThongTinDDATForm");
const AdminUpdateThongTinDDATForm = () =>
  import("@/views/admin/DDAT/UpdateThongTinDDAT");
const UpdateDDATForm = () => import("@/views/admin/DDAT/UpdateDDATForm");
const AdminUpdateDDAT = () => import("@/views/admin/DDAT/AdminUpdateDDAT");
const AdminThongTinForm = () => import("@/views/admin/ThongTin/ThongTinForm");
const AdminPhanHoiList = () => import("@/views/admin/PhanHoi/PhanHoiList");
const AdminPhanHoiForm = () => import("@/views/admin/PhanHoi/PhanHoiForm");
const AdminLichSuPhanHoiList = () =>
  import("@/views/admin/PhanHoi/LichSuPhanHoiList");
const AdminLichSuPhanHoiForm = () =>
  import("@/views/admin/PhanHoi/LichSuPhanHoiForm");
const AdminKhachDuLichList = () =>
  import("@/views/admin/KhachDuLich/KhachDuLichList");
const AdminKhachDuLichForm = () =>
  import("@/views/admin/KhachDuLich/KhachDuLichForm");
const AdminCongTyLuHanhList = () =>
  import("@/views/admin/CongTyLuHanh/CongTyLuHanhList");
const AdminCongTyLuHanhForm = () =>
  import("@/views/admin/CongTyLuHanh/CongTyLuHanhForm");
const ThongTinCongTyLuHanhForm = () =>
  import("@/views/admin/CongTyLuHanh/ThongTinCongTyLuHanh");
const ChinhSachVaQuyenLoi = () =>
  import("@/views/admin/ChinhSach/ChinhSachVaQuyenLoi");
const QRCode = () => import("@/views/admin/QrCode/QrCode");
const AdminDichVuGiaiTriList = () =>
  import("@/views/admin/DichVuGiaiTri/DichVuGiaiTriList");
const AdminDichVuGiaiTriForm = () =>
  import("@/views/admin/DichVuGiaiTri/DichVuGiaiTriForm");
const AdminLichSuDichVuGiaiTriList = () =>
  import("@/views/admin/DichVuGiaiTri/LichSuDichVuGiaiTriList");
const AdminLichSuDichVuGiaiTriForm = () =>
  import("@/views/admin/DichVuGiaiTri/LichSuDichVuGiaiTriForm");
const AdminDichVuLuuTruList = () =>
  import("@/views/admin/DichVuLuuTru/DichVuLuuTruList");
const AdminDichVuLuuTruForm = () =>
  import("@/views/admin/DichVuLuuTru/DichVuLuuTruForm");
const AdminLichSuDichVuLuuTruList = () =>
  import("@/views/admin/DichVuLuuTru/LichSuDichVuLuuTruList");
const AdminLichSuDichVuLuuTruForm = () =>
  import("@/views/admin/DichVuLuuTru/LichSuDichVuLuuTruForm");
const AdminDichVuAmThucList = () =>
  import("@/views/admin/DichVuAmThuc/DichVuAmThucList");
const AdminDichVuAmThucForm = () =>
  import("@/views/admin/DichVuAmThuc/DichVuAmThucForm");
const AdminLichSuDichVuAmThucList = () =>
  import("@/views/admin/DichVuAmThuc/LichSuDichVuAmThucList");
const AdminLichSuDichVuAmThucForm = () =>
  import("@/views/admin/DichVuAmThuc/LichSuDichVuAmThucForm");
const AdminDichVuVanTaiKhachList = () =>
  import("@/views/admin/DichVuVanTaiKhach/DichVuVanTaiKhachList");
const AdminDichVuVanTaiKhachForm = () =>
  import("@/views/admin/DichVuVanTaiKhach/DichVuVanTaiKhachForm");
const AdminLichSuDichVuVanTaiKhachList = () =>
  import("@/views/admin/DichVuVanTaiKhach/LichSuDichVuVanTaiKhachList");
const AdminLichSuDichVuVanTaiKhachForm = () =>
  import("@/views/admin/DichVuVanTaiKhach/LichSuDichVuVanTaiKhachForm");
const AdminGioiThieuList = () =>
  import("@/views/admin/GioiThieu/GioiThieuList");
const AdminGioiThieuForm = () =>
  import("@/views/admin/GioiThieu/GioiThieuForm");
const AdminNguonTinTucList = () =>
  import("@/views/admin/NguonTinTuc/NguonTinTucList");
const AdminNguonTinTucForm = () =>
  import("@/views/admin/NguonTinTuc/NguonTinTucForm");
const AdminBangGiaQuangCaoList = () =>
  import("@/views/admin/BangGiaQuangCao/BangGiaQuangCaoList");
const AdminBangGiaQuangCaoForm = () =>
  import("@/views/admin/BangGiaQuangCao/BangGiaQuangCaoForm");
// const AdminDuLieuAnToanHangNgay = () =>
//   import('@/views/admin/DuLieuAnToanHangNgay/DuLieuAnToanHangNgay')
// const DanhGiaAnToanHangNgay = () =>
//   import('@/views/admin/DanhGiaAnToanHangNgay/DanhGiaAnToanHangNgay')
// const DanhGiaAnToanHangNgayForm = () =>
//   import('@/views/admin/DanhGiaAnToanHangNgay/DanhGiaAnToanHangNgayForm')
// const DanhGiaAnToanHangNgayListSuccess = () =>
//   import('@/views/admin/DanhGiaAnToanHangNgay/DanhGiaAnToanHangNgayListSuccess')
const AdminCheckinDDATList = () =>
  import("@/views/admin/CheckinDDAT/CheckinDDATList");
const NenTangDichVuList = () =>
  import("@/views/admin/NenTangDichVu/NenTangDichVuList");
const NenTangDichVuForm = () =>
  import("@/views/admin/NenTangDichVu/NenTangDichVuForm");
const UpdateDDATSuccess = () => import("@/views/admin/DDAT/UpdateDDATSuccess");
const AdminUpdateDDATSuccess = () =>
  import("@/views/admin/DDAT/AdminUpdateDDATSuccess");
const AdminDanhGiaList = () => import("@/views/admin/DanhGia/DanhGiaList");
const AdminDanhGiaForm = () => import("@/views/admin/DanhGia/DanhGiaForm");
const TourAgentDanhGiaList = () =>
  import("@/views/admin/DanhGiaTourAgent/DanhGiaList");
const TourAgentDanhGiaForm = () =>
  import("@/views/admin/DanhGiaTourAgent/DanhGiaForm");
const AdminBaiDangDiemDenList = () =>
  import("@/views/admin/TinTuc/BaiDangDiemDenList");
const AdminBaiDangDiemDenForm = () =>
  import("@/views/admin/TinTuc/BaiDangDiemDenForm");
const AdminQuanLyPhong = () => import("@/views/admin/RoomManager/RoomManager");
const AdminQuanLyBanHang = () =>
  import("@/views/admin/SalesManager/SalesManager");
const AdminDangKyTaiKhoanNganHang = () =>
  import("@/views/admin/SignUpBankAccount/SignUpBankAccount");
const AdminDangKyTaiKhoanNganHang2 = () =>
  import("@/views/admin/SignUpBankAccount-2/SignUpBankAccount-2");
const AdminAutomaticCommentaryList = () =>
  import("@/views/admin/AutomaticCommentary/AutomaticCommentaryList");
const AdminAutomaticCommentaryForm = () =>
  import("@/views/admin/AutomaticCommentary/AutomaticCommentaryForm");
const BaoCaoThongKe = () => import("@/views/admin/BaoCaoThongKe/BaoCaoThongKe");
const GoToClient = () => import("@/views/admin/GoToClient/GoToClient");
const AdminQuanLyBannerList = () =>
  import("@/views/admin/QuanLyBanner/QuanLyBannerList");
const SetToken = () => import("@/views/SetToken");
// Views - auth
const AuthPage404 = () => import("@/views/auth/Page404");
const AuthLogin = () => import("@/views/auth/Login");
const AuthRegister = () => import("@/views/auth/Register");
const AuthChangePassword = () => import("@/views/auth/ChangePassword");
const AuthForgotPassword = () => import("@/views/auth/ForgotPassword");
const AuthResetPassword = () => import("@/views/auth/ResetPassword");
const AdminDangKyChuongTrinhKichCauList = () =>
  import("@/views/admin/DangKyChuongTrinhKichCau/DangKyChuongTrinhKichCauList");
const AdminDangKyChuongTrinhKichCauForm = () =>
  import("@/views/admin/DangKyChuongTrinhKichCau/DangKyChuongTrinhKichCauForm");
// Views - client
// const ClientHome = () =>
//     import ('@/views/client/Home')
const ClientDashboard = () => import("@/views/client/Dashboard");
const AdminTourList = () => import("@/views/admin/Tour/TourList");
const AdminTourForm = () => import("@/views/admin/Tour/TourForm");
const PhieuDieuTourList = () =>
  import("@/views/admin/PhieuDieuTour/PhieuDieuTourList");
const PhieuDieuTourForm = () =>
  import("@/views/admin/PhieuDieuTour/PhieuDieuTourForm");
const HuongDanVienDaDanList = () =>
  import("@/views/admin/HuongDanVien/HuongDanVienDaDanList");
const AdminHuongDanVienDaDanForm = () =>
  import("@/views/admin/HuongDanVien/HuongDanVienDaDanForm");
const AdminQuanLyVanBanList = () =>
  import("@/views/admin/QuanLyVanBan/QuanLyVanBanList");
const AdminQuanLyVanBanCreate = () =>
  import("@/views/admin/QuanLyVanBan/QuanLyVanBanForm");
const AdminThongBaoList = () => import("@/views/admin/ThongBao/ThongBaoList");
const AdminThongBaoForm = () => import("@/views/admin/ThongBao/ThongBaoForm");
Vue.use(Router);
/* Các quyền người dùng: BuiltinAdmin - Tài khoản super admin, Admin - Quản trị hệ thống, Officer - Quản lý nhà nước, TourGuide - Hướng dẫn viên du lịch, TourAgent - Công ty lữ hành, User - người dùng */
//ex roles: ['BuiltinAdmin ', 'Admin', 'TourGuide', 'TourAgent', 'User']

const router = new Router({
  base: config.pathDefault,
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: [
    {
      path: "/",
      redirect: config.defaultRouter,
      component: DefaultContainerClient,
    },
    // {
    //   path: '/home',
    //   name: 'Client-Home',
    //   component: ClientHome,
    //   meta: {
    //     allowAccess: ['*'],
    //     page: 'client'
    //   },
    // },
    {
      path: "/admin",
      redirect: "/admin/home",
      component: DefaultContainer,
      children: [
        {
          path: "home",
          name: "Admin-Home",
          component: AdminDashboard,
          meta: {
            allowAccess: ["*"],
            page: "admin",
          },
        },
        {
          path: "/",
          name: "AdminDashboard",
          component: AdminDashboard,
          meta: {
            allowAccess: ["*"],
            page: "admin",
          },
        },
        {
          path: "DangKyChuongTrinhKichCau",
          name: "Admin-DangKyChuongTrinhKichCau",
          redirect: "/admin/DangKyChuongTrinhKichCau/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "pending",
              name: "Admin-DangKyChuongTrinhKichCau-ChoDuyet-list",
              component: AdminDangKyChuongTrinhKichCauList,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Officer",
                  "TrangVangCompanyManager",
                ],
                page: "admin",
              },
            },
            {
              path: "approved",
              name: "Admin-DangKyChuongTrinhKichCau-DaDuyet-list",
              component: AdminDangKyChuongTrinhKichCauList,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Officer",
                  "TrangVangCompanyManager",
                ],
                page: "admin",
              },
            },
            {
              path: "pending/:id",
              name: "Admin-DangKyChuongTrinhKichCau-pending",
              component: AdminDangKyChuongTrinhKichCauForm,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Officer",
                  "TrangVangCompanyManager",
                ],
                page: "admin",
              },
            },
            {
              path: "approved/:id",
              name: "Admin-DangKyChuongTrinhKichCau-approved",
              component: AdminDangKyChuongTrinhKichCauForm,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Officer",
                  "TrangVangCompanyManager",
                ],
                page: "admin",
              },
            },
          ],
        },

        {
          path: "RoomManager",
          name: "Admin-RoomManager",
          component: AdminQuanLyPhong,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          path: "SalesManager",
          name: "Admin-SalesManager",
          component: AdminQuanLyBanHang,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          path: "SignUpBankAccount",
          name: "Admin-SignUpBankAccount",
          component: AdminDangKyTaiKhoanNganHang,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          path: "SignUpBankAccount-2",
          name: "Admin-SignUpBankAccount-2",
          component: AdminDangKyTaiKhoanNganHang2,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          path: "UpdateDDAT",
          name: "Admin-UpdateDDAT",
          redirect: "/admin/UpdateDDAT",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "success",
              name: "Admin-UpdateDDAT-success",
              component: UpdateDDATSuccess,
              meta: {
                allowAccess: ["*"],
                page: "admin",
              },
            },
            {
              path: "adminSuccess",
              name: "Admin-UpdateDDAT-success",
              component: AdminUpdateDDATSuccess,
              meta: {
                allowAccess: ["*"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "QuangCao",
          name: "Admin-QuangCao",
          redirect: "/admin/QuangCao/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-QuangCao-list",
              component: AdminQuangCaoList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-QuangCao-create",
              component: AdminQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-QuangCao-update",
              component: AdminQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-QuangCao-detail",
              component: AdminQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-QuangCao-history",
              component: LichSuQuangCaoList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-QuangCao-accept",
              component: LichSuQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NguoiDung",
          name: "Admin-NguoiDung",
          redirect: "/admin/NguoiDung/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-NguoiDung-list",
              component: AdminNguoiDungList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-NguoiDung-create",
              component: AdminNguoiDungForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-NguoiDung-update",
              component: AdminNguoiDungForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-NguoiDung-detail",
              component: AdminNguoiDungForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "LienHe",
          name: "Admin-LienHe",
          redirect: "/admin/LienHe/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-LienHe-list",
              component: AdminLienHeList,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-LienHe-detail",
              component: AdminLienHeForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "Tour",
          name: "Admin-Tour",
          redirect: "/admin/Tour/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-Tour-list",
              component: AdminTourList,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-Tour-create",
              component: AdminTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-Tour-update",
              component: AdminTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-Tour-detail",
              component: AdminTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "PhieuDieuTour",
          name: "Admin-PhieuDieuTour",
          redirect: "/admin/PhieuDieuTour/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-PhieuDieuTour-list",
              component: PhieuDieuTourList,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-PhieuDieuTour-create",
              component: PhieuDieuTourForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-PhieuDieuTour-update",
              component: PhieuDieuTourForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-PhieuDieuTour-detail",
              component: PhieuDieuTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDichVu/TourDuLich",
          name: "Admin-TourDuLich",
          redirect: "/admin/TourDuLich/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-TourDuLich-list",
              component: AdminTourDuLichList,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourAgent_Pending",
                ],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-TourDuLich-create",
              component: AdminTourDuLichForm,
              meta: {
                allowAccess: ["TourAgent", "TourAgent_Pending"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-TourDuLich-create-admin",
              component: AdminTourDuLichForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-TourDuLich-update",
              component: AdminTourDuLichForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourAgent_Pending",
                ],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-TourDuLich-detail",
              component: AdminTourDuLichForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourAgent_Pending",
                ],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-TourDuLich-history",
              component: LichSuTourDuLichList,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourAgent_Pending",
                ],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-TourDuLich-accept",
              component: LichSuTourDuLichForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-TourDuLich-detail-history",
              component: LichSuTourDuLichForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourAgent_Pending",
                ],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-TourDuLich-update-history",
              component: LichSuTourDuLichForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourAgent_Pending",
                ],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDichVu/DiemDen",
          name: "Admin-DiemDen",
          redirect: "/admin/DiemDen/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DiemDen-list",
              component: AdminDiemDenList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-DiemDen-create",
              component: AdminDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-DiemDen-create-admin",
              component: AdminDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DiemDen-update",
              component: AdminDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DiemDen-detail",
              component: AdminDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-DiemDen-history",
              component: LichSuDiemDenList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DiemDen-accept",
              component: LichSuDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-DiemDen-update-history",
              component: LichSuDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-DiemDen-detail-history",
              component: LichSuDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "refuse/:id",
              name: "Admin-VuiChoiGiaiTri-refuse",
              component: AdminDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "DiemDenForm",
          name: "Admin-DiemDenForm",
          redirect: "/admin/DiemDenForm/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "create",
              name: "Admin-DiemDenForm-create",
              component: AdminDiemDenFormCreate,
              meta: {
                allowAccess: ["Destination"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DichVuDiemDen",
          name: "Admin-DichVuDiemDen",
          redirect: "/admin/DichVuDiemDen/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuDiemDen-list",
              component: AdminDichVuDiemDenList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuDiemDen-detail",
              component: AdminDichVuDiemDenForm,
              meta: {
                allowAccess: ["SafePlace", "Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DichVuDiemDen-update",
              component: AdminUpdateDDAT,
              meta: {
                allowAccess: ["Officer", "Admin"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-DichVuDiemDen-history",
              component: AdminLichSuDichVuDiemDenList,
              meta: {
                allowAccess: ["Officer", "Admin"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DichVuDiemDen-accept",
              component: AdminLichSuDichVuDiemDenForm,
              meta: {
                allowAccess: ["Officer", "Admin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "HuongDanVienDaDan",
          name: "Admin-HuongDanVienDaDan",
          redirect: "/admin/HuongDanVienDaDan/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-HuongDanVienDaDan-list",
              component: HuongDanVienDaDanList,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-HuongDanVienDaDan-detail",
              component: AdminHuongDanVienDaDanForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ThongTinDichVuDiemDen",
          name: "Admin-ThongTinDichVuDiemDen",
          redirect: "/admin/ThongTinDichVuDiemDen/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "detail",
              name: "Admin-ThongTinDichVuDiemDen-detail",
              component: AdminThongTinDDATForm,
              meta: {
                allowAccess: ["Destination"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-ThongTinDichVuDiemDen-update",
              component: AdminUpdateThongTinDDATForm,
              meta: {
                allowAccess: ["Destination"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DDAT",
          name: "Admin-DDAT",
          redirect: "/admin/DDAT/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DDAT-list",
              component: AdminDDATList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DDAT-detail",
              component: AdminDDATForm,
              meta: {
                allowAccess: ["SafePlace", "Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DDAT-update",
              component: AdminUpdateDDAT,
              meta: {
                allowAccess: ["Officer", "Admin"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ThongTinDDAT",
          name: "Admin-ThongTinDDAT",
          redirect: "/admin/ThongTinDDAT/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "detail",
              name: "Admin-ThongTinDDAT-detail",
              component: AdminThongTinDDATForm,
              meta: {
                allowAccess: ["SafePlace", "Ticket", "Destination"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-ThongTinDDAT-update",
              component: UpdateDDATForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDichVu/LuuTru",
          name: "Admin-LuuTru",
          redirect: "/admin/LuuTru/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-LuuTru-list",
              component: AdminLuuTruList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-LuuTru-update",
              component: AdminLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-LuuTru-create-admin",
              component: AdminLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-LuuTru-create",
              component: AdminLuuTruForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-LuuTru-detail",
              component: AdminLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-LuuTru-history",
              component: LichSuLuuTruList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-LuuTru-detail-history",
              component: LichSuLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-LuuTru-update-history",
              component: LichSuLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-LuuTru-accept",
              component: LichSuLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/CongTyLuHanh",
          name: "Admin-CongTyLuHanh",
          redirect: "/admin/CongTyLuHanh/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-CongTyLuHanh-list",
              component: AdminCongTyLuHanhList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-CongTyLuHanh-detail",
              component: AdminCongTyLuHanhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ThongTinCongTyLuHanh",
          name: "Admin-ThongTinCongTyLuHanh",
          redirect: "/admin/ThongTinCongTyLuHanh/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "detail",
              name: "Admin-ThongTinCongTyLuHanh-detail",
              component: ThongTinCongTyLuHanhForm,
              meta: {
                allowAccess: ["TourAgent", "TourAgent_Pending"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DichVuGiaiTri",
          name: "Admin-DichVuGiaiTri",
          redirect: "/admin/DichVuGiaiTri/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuGiaiTri-list",
              component: AdminDichVuGiaiTriList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuGiaiTri-detail",
              component: AdminDichVuGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-DichVuGiaiTri-history",
              component: AdminLichSuDichVuGiaiTriList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DichVuGiaiTri-accept",
              component: AdminLichSuDichVuGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DichVuLuuTru",
          name: "Admin-DichVuLuuTru",
          redirect: "/admin/DichVuLuuTru/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuLuuTru-list",
              component: AdminDichVuLuuTruList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuLuuTru-detail",
              component: AdminDichVuLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DichVuLuuTru-update",
              component: AdminUpdateDDAT,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-DichVuLuuTru-history",
              component: AdminLichSuDichVuLuuTruList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DichVuLuuTru-accept",
              component: AdminLichSuDichVuLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DichVuAmThuc",
          name: "Admin-DichVuAmThuc",
          redirect: "/admin/DichVuAmThuc/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuAmThuc-list",
              component: AdminDichVuAmThucList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuAmThuc-detail",
              component: AdminDichVuAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-DichVuAmThuc-history",
              component: AdminLichSuDichVuAmThucList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DichVuAmThuc-accept",
              component: AdminLichSuDichVuAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DichVuVanTaiKhach",
          name: "Admin-DichVuVanTaiKhach",
          redirect: "/admin/DichVuVanTaiKhach/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuVanTaiKhach-list",
              component: AdminDichVuVanTaiKhachList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuVanTaiKhach-detail",
              component: AdminDichVuVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DichVuVanTaiKhach-update",
              component: AdminUpdateDDAT,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-DichVuVanTaiKhach-history",
              component: AdminLichSuDichVuVanTaiKhachList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DichVuVanTaiKhach-accept",
              component: AdminLichSuDichVuVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDichVu/AmThuc",
          name: "Admin-AmThuc",
          redirect: "/admin/AmThuc/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-AmThuc-list",
              component: AdminAmThucList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-AmThuc-update",
              component: AdminAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-AmThuc-create",
              component: AdminAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-AmThuc-create-admin",
              component: AdminAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-AmThuc-detail",
              component: AdminAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-AmThuc-history",
              component: LichSuAmThucList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-AmThuc-update-history",
              component: LichSuAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-AmThuc-detail-history",
              component: LichSuAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-AmThuc-accept",
              component: LichSuAmThucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "AmThucForm",
          name: "Admin-AmThucForm",
          redirect: "/admin/AmThucForm/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "create",
              name: "Admin-AmThucForm-create",
              component: AdminAmThucFormCreate,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-AmThucForm-deatil",
              component: AdminAmThucFormCreate,
              meta: {
                allowAccess: ["Cuisine"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "VeMayBay",
          name: "Admin-VeMayBay",
          redirect: "/admin/VeMayBay/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-VeMayBay-list",
              component: AdminVeMayBayList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-VeMayBay-create-admin",
              component: AdminVeMayBayForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-VeMayBay-update",
              component: AdminVeMayBayForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-VeMayBay-detail",
              component: AdminVeMayBayForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "VeGiaoThong",
          name: "Admin-VeGiaoThong",
          redirect: "/admin/VeGiaoThong/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-VeGiaoThong-list",
              component: AdminVeGiaoThongList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-VeGiaoThong-create-admin",
              component: AdminVeGiaoThongForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-VeGiaoThong-update",
              component: AdminVeGiaoThongForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-VeGiaoThong-detail",
              component: AdminVeGiaoThongForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDichVu/VeDienTu",
          name: "Admin-VeDienTu",
          redirect: "/admin/VeDienTu/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-VeDienTu-list",
              component: AdminVeDienTuList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-VeDienTu-create",
              component: AdminVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-VeDienTu-update",
              component: AdminVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-VeDienTu-detail",
              component: AdminVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-VeDienTu-create-admin",
              component: AdminVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-VeDienTu-history",
              component: AdminLichSuVeDienTuList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-VeDienTu-detail-history",
              component: AdminLichSuVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-VeDienTu-update-history",
              component: AdminLichSuVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-VeDienTu-accept",
              component: AdminLichSuVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },

        {
          path: "BaiDangDichVu/VanTaiKhach",
          name: "Admin-VanTaiKhach",
          redirect: "/admin/VanTaiKhach/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-VanTaiKhach-list",
              component: AdminVanTaiKhachList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-VanTaiKhach-update",
              component: AdminVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-VanTaiKhach-create",
              component: AdminVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-VanTaiKhach-create-admin",
              component: AdminVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-VanTaiKhach-detail",
              component: AdminVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-VanTaiKhach-history",
              component: LichSuVanTaiKhachList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-VanTaiKhach-update-history",
              component: LichSuVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-VanTaiKhach-detail-history",
              component: LichSuVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-VanTaiKhach-accept",
              component: LichSuVanTaiKhachForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NhaCungCapDichVu/DichVuVeDienTu",
          name: "Admin-CongTyLuHanh",
          redirect: "/admin/DichVuVeDienTu/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuVeDienTu-list",
              component: AdminDichVuVeDienTuList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuVeDienTu-detail",
              component: AdminDichVuVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            // {
            //     path: 'update/:id',
            //     name: 'Admin-DichVuVeDienTu-update',
            //     component: AdminDichVuVeDienTuForm,
            //     meta: {
            //         allowAccess: ['Admin', 'Officer'],
            //         page: 'admin'
            //     }
            // },
            {
              path: "history",
              name: "Admin-DichVuVeDienTu-history",
              component: AdminLichSuDichVuVeDienTuList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-DichVuVeDienTu-accept",
              component: AdminLichSuDichVuVeDienTuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "VeDienTuForm",
          name: "Admin-VeDienTuForm",
          redirect: "/admin/VeDienTu/VeDienTuForm/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "create",
              name: "Admin-VeDienTuForm-create",
              component: AdminVeDienTuFormUpdate,
              meta: {
                allowAccess: ["Ticket"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "SanVat",
          name: "Admin-SanVat",
          redirect: "/admin/SanVat/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-SanVat-list",
              component: AdminSanVatList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-SanVat-create",
              component: AdminSanVatForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-SanVat-update",
              component: AdminSanVatForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-SanVat-detail",
              component: AdminSanVatForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDichVu/GiaiTri",
          name: "Admin-VuiChoiGiaiTri",
          redirect: "/admin/GiaiTri/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-VuiChoiGiaiTri-list",
              component: AdminVuiChoiGiaiTriList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-VuiChoiGiaiTri-create",
              component: AdminVuiChoiGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create-admin/:id",
              name: "Admin-VuiChoiGiaiTri-create-admin",
              component: AdminVuiChoiGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create-history/:id",
              name: "Admin-VuiChoiGiaiTri-create-history",
              component: LichSuGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-VuiChoiGiaiTri-update",
              component: AdminVuiChoiGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-VuiChoiGiaiTri-detail",
              component: AdminVuiChoiGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-VuiChoiGiaiTri-history",
              component: LichSuGiaiTriList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-VuiChoiGiaiTri-accept",
              component: LichSuGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "refuse/:id",
              name: "Admin-VuiChoiGiaiTri-refuse",
              component: AdminVuiChoiGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update-history/:id",
              name: "Admin-VuiChoiGiaiTri-update-history",
              component: LichSuGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail-history/:id",
              name: "Admin-VuiChoiGiaiTri-detail-history",
              component: LichSuGiaiTriForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "GiaiTriForm",
          name: "Admin-GiaiTriForm",
          redirect: "/admin/GiaiTriForm/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "create",
              name: "Admin-GiaiTriForm-create",
              component: AdminGiaiTriFormCreate,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "TinTuc",
          name: "Admin-TinTuc",
          redirect: "/admin/TinTuc/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-TinTuc-list",
              component: AdminTinTucList,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-TinTuc-create",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-TinTuc-update",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-TinTuc-detail",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "QuanLyVanBan",
          name: "Admin-QuanLyVanBan",
          redirect: "/admin/QuanLyVanBan/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-QuanLyVanBan-list",
              component: AdminQuanLyVanBanList,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-QuanLyVanBan-create",
              component: AdminQuanLyVanBanCreate,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "QuanLyBanner",
          name: "Admin-QuanLyBanner",
          redirect: "/admin/QuanLyBanner/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-QuanLyBanner-list",
              component: AdminQuanLyBannerList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ThongTin",
          name: "Admin-ThongTin",
          redirect: "/admin/ThongTin/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-ThongTin-list",
              component: AdminThongTinForm,
              meta: {
                allowAccess: ["User"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "PhanHoi",
          name: "Admin-PhanHoi",
          redirect: "/admin/PhanHoi/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-PhanHoi-list",
              component: AdminPhanHoiList,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Admin",
                  "Officer",
                  "SafePlace",
                  "TourAgent",
                  "TourAgent_Pending",
                  "TrangVangContentManager",
                ],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-PhanHoi-detail",
              component: AdminPhanHoiForm,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Admin",
                  "Officer",
                  "SafePlace",
                  "TourAgent",
                  "TourAgent_Pending",
                  "TrangVangContentManager",
                ],
                page: "admin",
              },
            },
            {
              path: "history",
              name: "Admin-PhanHoi-history",
              component: AdminLichSuPhanHoiList,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Admin",
                  "Officer",
                  "TrangVangContentManager",
                ],
                page: "admin",
              },
            },
            {
              path: "accept/:id",
              name: "Admin-PhanHoi-accept",
              component: AdminLichSuPhanHoiForm,
              meta: {
                allowAccess: [
                  "VNATAdmin",
                  "Admin",
                  "Officer",
                  "TrangVangContentManager",
                ],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "CheckinDDAT",
          name: "Admin-CheckinDDAT",
          redirect: "/admin/CheckinDDAT/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-CheckinDDAT-list",
              component: AdminCheckinDDATList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "KhachDuLich",
          name: "Admin-KhachDuLich",
          redirect: "/admin/KhachDuLich/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-KhachDuLich-list",
              component: AdminKhachDuLichList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-KhachDuLich-detail",
              component: AdminKhachDuLichForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ChinhSachVaQuyenLoi",
          name: "ChinhSachVaQuyenLoi",
          redirect: "/admin/ChinhSachVaQuyenLoi",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "infomation",
              name: "Admin-ChinhSachVaQuyenLoi-infomation",
              component: ChinhSachVaQuyenLoi,
              meta: {
                allowAccess: [
                  "TourAgent",
                  "TourAgent_Pending",
                  "SafePlace",
                  "Ticket",
                  "Entertainment",
                  "Destination",
                  "Cuisine",
                ],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "QRCode",
          name: "QRCode",
          redirect: "/admin/QRCode",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "infomation",
              name: "Admin-QRCode-infomation",
              component: QRCode,
              meta: {
                allowAccess: ["TourAgent", "SafePlace", "TourAgent_Pending"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "GioiThieu",
          name: "Admin-GioiThieu",
          redirect: "/admin/GioiThieu/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-GioiThieu-list",
              component: AdminGioiThieuList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-GioiThieu-detail",
              component: AdminGioiThieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-GioiThieu-create",
              component: AdminGioiThieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-GioiThieu-update",
              component: AdminGioiThieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "NguonTinTuc",
          name: "Admin-NguonTinTuc",
          redirect: "/admin/NguonTinTuc/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-NguonTinTuc-list",
              component: AdminNguonTinTucList,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-NguonTinTuc-update",
              component: AdminNguonTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-NguonTinTuc-create",
              component: AdminNguonTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-NguonTinTuc-detail",
              component: AdminNguonTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BangGiaQuangCao",
          name: "Admin-BangGiaQuangCao",
          redirect: "/admin/NguonBangGiaQuangCao/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-BangGiaQuangCao-list",
              component: AdminBangGiaQuangCaoList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-BangGiaQuangCao-update",
              component: AdminBangGiaQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-BangGiaQuangCao-create",
              component: AdminBangGiaQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-BangGiaQuangCao-detail",
              component: AdminBangGiaQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin",
              },
            },
          ],
        },
        // {
        //   path: 'DuLieuAnToanHangNgay',
        //   name: 'Admin-LichBieuKBAT',
        //   component: AdminDuLieuAnToanHangNgay,
        //   meta: {
        //     allowAccess: ['SafePlace'],
        //     page: 'admin'
        //   }
        // },
        // {
        //   path: 'DanhGiaAnToanHangNgay',
        //   name: 'Admin-DanhGiaAnToanHangNgay',
        //   redirect: '/admin/DanhGiaAnToanHangNgay/day',
        //   component: {
        //     render(c) {
        //       return c('router-view')
        //     }
        //   },
        //   children: [
        //     {
        //       path: 'success',
        //       name: 'Admin-DanhGiaAnToanHangNgay-success',
        //       component: DanhGiaAnToanHangNgayListSuccess,
        //       meta: {
        //         allowAccess: ['SafePlace'],
        //         page: 'admin'
        //       }
        //     },
        //     {
        //       path: 'day',
        //       name: 'Admin-DanhGiaAnToanHangNgay-day',
        //       component: DanhGiaAnToanHangNgay,
        //       meta: {
        //         allowAccess: ['SafePlace'],
        //         page: 'admin'
        //       }
        //     },
        //     {
        //       path: 'daily/:id',
        //       name: 'Admin-DanhGiaAnToanHangNgay-daily',
        //       component: DanhGiaAnToanHangNgayForm,
        //       meta: {
        //         allowAccess: ['SafePlace'],
        //         page: 'admin'
        //       }
        //     }
        //   ]
        // },
        {
          path: "NenTangDichVu",
          name: "Admin-NenTangDichVu",
          redirect: "/admin/NenTangDichVu/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-NenTangDichVu-list",
              component: NenTangDichVuList,
              meta: {
                allowAccess: ["Officer"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-NenTangDichVu-update",
              component: NenTangDichVuForm,
              meta: {
                allowAccess: ["Officer"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-NenTangDichVu-create",
              component: NenTangDichVuForm,
              meta: {
                allowAccess: ["Officer"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-NenTangDichVu-detail",
              component: NenTangDichVuForm,
              meta: {
                allowAccess: ["Officer"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "DanhGia",
          name: "Admin-DanhGia",
          redirect: "/admin/DanhGia/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGia-list",
              component: TourAgentDanhGiaList,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DanhGia-update",
              component: TourAgentDanhGiaForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            // {
            //     path: 'create',
            //     name: 'Admin-DanhGia-create',
            //     component: AdminDanhGiaForm,
            //     meta: {
            //         allowAccess: ['Officer'],
            //         page: 'admin'
            //     }
            // },
            {
              path: "detail/:id",
              name: "Admin-DanhGia-detail",
              component: TourAgentDanhGiaForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "DanhGia",
          name: "Admin-DanhGia",
          redirect: "/admin/DanhGia/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGia-list",
              component: TourAgentDanhGiaList,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-DanhGia-update",
              component: TourAgentDanhGiaForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
            // {
            //     path: 'create',
            //     name: 'Admin-DanhGia-create',
            //     component: AdminDanhGiaForm,
            //     meta: {
            //         allowAccess: ['Officer'],
            //         page: 'admin'
            //     }
            // },
            {
              path: "detail/:id",
              name: "Admin-DanhGia-detail",
              component: AdminDanhGiaForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "ThongBao",
          name: "Admin-ThongBao",
          redirect: "/admin/ThongBao/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-ThongBao-list",
              component: AdminThongBaoList,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-ThongBao-create",
              component: AdminThongBaoForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-ThongBao-update",
              component: AdminThongBaoForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-ThongBao-detail",
              component: AdminThongBaoForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaiDangDiemDen",
          name: "Admin-BaiDangDiemDen",
          redirect: "/admin/BaiDangDiemDen/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-BaiDangDiemDen-list",
              component: AdminBaiDangDiemDenList,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "update/:id",
              name: "Admin-BaiDangDiemDen-update",
              component: AdminBaiDangDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-BaiDangDiemDen-create",
              component: AdminBaiDangDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
            {
              path: "detail/:id",
              name: "Admin-BaiDangDiemDen-detail",
              component: AdminBaiDangDiemDenForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TrangVangContentManager"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "AutomaticCommentary",
          name: "Admin-AutomaticCommentary",
          redirect: "/admin/AutomaticCommentary/list",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "list",
              name: "Admin-AutomaticCommentary-list",
              component: AdminAutomaticCommentaryList,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
            {
              path: "create",
              name: "Admin-AutomaticCommentary-create",
              component: AdminAutomaticCommentaryForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
            {
              path: "update/:code",
              name: "Admin-AutomaticCommentary-update",
              component: AdminAutomaticCommentaryForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
            {
              path: "detail/:code",
              name: "Admin-AutomaticCommentary-detail",
              component: AdminAutomaticCommentaryForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin",
              },
            },
          ],
        },
        {
          path: "BaoCaoThongKe",
          name: "Admin-BaoCaoThongKe",
          component: BaoCaoThongKe,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
        {
          path: "GoToClient",
          name: "Admin-GoToClient",
          component: GoToClient,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin",
          },
        },
      ],
    },
    {
      path: "/auth",
      redirect: "/auth/login",
      name: "Auth",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      beforeEnter: (to, from, next) => {
        clearInterval(window.reqIntervalPhanHoi);
        clearInterval(window.reqIntervalDiemDen);
        clearInterval(window.reqIntervalTour);
        clearInterval(window.reqIntervalLuuTru);
        clearInterval(window.reqIntervalAmThuc);
        clearInterval(window.reqIntervalGiaiTri);
        clearInterval(window.reqIntervalVeDienTu);
        clearInterval(window.reqIntervalDichVuDiemDen);
        clearInterval(window.reqIntervalDichVuLuuTru);
        clearInterval(window.reqIntervalDichVuAmThuc);
        clearInterval(window.reqIntervalDichVuGiaiTri);
        clearInterval(window.reqIntervalDichVuVeDienTu);
        clearInterval(window.reqIntervalAds);
        next();
      },
      children: [
        {
          path: "404",
          name: "Auth-Page404",
          component: AuthPage404,
          meta: {
            page: "auth",
          },
        },
        {
          path: "login",
          name: "Auth-Login",
          component: AuthLogin,
          meta: {
            page: "auth",
          },
        },
        {
          path: "register",
          name: "Auth-Register",
          component: AuthRegister,
          meta: {
            page: "auth",
          },
        },
        {
          path: "changepassword",
          name: "Auth-ChangePassword",
          component: AuthChangePassword,
          meta: {
            page: "auth",
          },
        },
        {
          path: "forgotPassword",
          name: "Auth-ForgotPassword",
          component: AuthForgotPassword,
          meta: {
            page: "auth",
          },
        },
        {
          path: "resetPassword",
          name: "Auth-ResetPassword",
          component: AuthResetPassword,
          meta: {
            page: "auth",
          },
        },
      ],
    },
    {
      path: "/setToken.html",
      name: "SetToken",
      component: SetToken,
      meta: {
        page: "auth",
      },
    },
    {
      path: "/dashboard",
      name: "Client-Dashboard",
      component: ClientDashboard,
      meta: {
        page: "client",
      },
    },
  ],
});
export default router;

router.beforeEach(function (to, from, next) {
  if (from.name != to.name) {
    if (to.meta.page && to.meta.page == "admin") {
      AuthService.me()
        .then(async (res) => {
          window.localStorage.setItem(
            "currentUser",
            JSON.stringify(res.result)
          );
          if (to.meta.allowAccess && to.meta.allowAccess.indexOf("*") == 0) {
            if (res.result.roles.includes("SafePlace")) {
              let donViCungCapRes = await DonViCungCapApi.list({
                filters: "nguoi_tao=" + res.result.id,
              });
              let donViCungCapChoDuyetRes = await DonViCungCapChoDuyetApi.list({
                filters: "nguoi_tao=" + res.result.id,
              });
              if (
                donViCungCapChoDuyetRes.result[0] ||
                donViCungCapRes.result[0]
              ) {
                next();
              } else {
                // let diemDenAnToanRes = await DDATApi.list({
                //   filters: 'nguoi_tao_id=' + res.result.id
                // })
                // if (
                //     diemDenAnToanRes.result[0].loai_diem_den == 'restaurant' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'hotel' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'entertainment' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'ticket'||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'tourist_villa' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'tourist_apartment' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'camping' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'motel' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'homestay' ||
                //     diemDenAnToanRes.result[0].loai_diem_den == 'tourist_cruise'
                // ) {
                next();
                // } else {
                //     window.toastr.warning('Loại điểm đến không thuộc trang vàng 1234!')
                // }
              }
            } else {
              next();
            }
          } else {
            if (res.result && res.result.roles && res.result.roles.length > 0) {
              var access = false;
              res.result.roles.forEach((item) => {
                if (
                  to.meta.allowAccess &&
                  to.meta.allowAccess.indexOf(item) != -1
                ) {
                  access = true;
                }
              });
              if (access) {
                if (res.result.roles.includes("SafePlace")) {
                  let donViCungCapChoDuyetRes =
                    await DonViCungCapChoDuyetApi.list({
                      filters: "nguoi_tao=" + res.result.id,
                    });
                  let donViCungCapRes = await DonViCungCapApi.list({
                    filters: "nguoi_tao=" + res.result.id,
                  });
                  if (
                    donViCungCapChoDuyetRes.result[0] ||
                    donViCungCapRes.result[0]
                  ) {
                    if (
                      donViCungCapChoDuyetRes.result[0] &&
                      donViCungCapChoDuyetRes.result[0].id
                    ) {
                      window.localStorage.setItem(
                        "tv_don_vi_cung_caps",
                        donViCungCapChoDuyetRes.result[0].id
                      );
                    } else if (
                      donViCungCapRes.result[0] &&
                      donViCungCapRes.result[0].id
                    ) {
                      window.localStorage.setItem(
                        "tv_don_vi_cung_caps",
                        donViCungCapRes.result[0].id
                      );
                    }
                    next();
                  } else {
                    // let diemDenAnToanRes = await DDATApi.list({
                    //   filters: 'nguoi_tao_id=' + res.result.id
                    // })
                    // if (
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'restaurant' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'hotel' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'entertainment' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'ticket'||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'tourist_villa' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'tourist_apartment' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'camping' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'motel' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'homestay' ||
                    //     diemDenAnToanRes.result[0].loai_diem_den == 'tourist_cruise'
                    // ) {
                    next();
                    // } else {
                    //     window.toastr.warning('Loại điểm đến không thuộc trang vàng eer4wr345 ')
                    // }
                  }
                } else if (res.result.roles.includes("TourAgent_Pending")) {
                  Vue.prototype
                    .$confirm(
                      "Tài khoản của bạn vẫn đang trong quá trình chờ duyệt",
                      "Cảnh báo",
                      {
                        confirmButtonText: "Đóng",
                        type: "warning",
                      }
                    )
                    .then(() => {
                      next(false);
                    })
                    .catch(() => {
                      next(false);
                    });
                } else {
                  next();
                }
              } else {
                window.toastr.warning("Không có quyền");
              }
            }
          }
        })
        .catch((e) => {
          console.log("error 2808", e);

          window.localStorage.removeItem("currentUser");
          next("/auth/login");
        });
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
    } else {
      next("/auth/404");
    }
  } else {
    if (!to.name) {
      next("/auth/404");
    } else {
      next();
    }
  }
});
